import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import MobileDetect from 'mobile-detect';

const THEME1 = 'theme1';
const THEME2 = 'theme2';
const THEME3 = 'theme3';

const getTheme = theme => {
    switch (theme) {
        case '2':
            return THEME2;
        case '3':
            return THEME3;
        case '1':
        default:
            return THEME1;
    }
};

const CreditCardFeature = props => {
    const { title, content, img, imgAlign = 'left', partner } = props;
    const theme = getTheme(partner ? partner.get('theme') : THEME1);
    const builtImg = <img src={img} className="tc-accordion-feature-icon" />;
    const featureClassName = classNames(`row tc-accordion-feature ${theme}`, {
        [`tc-accordion-feature__with-background ${theme}`]: imgAlign === 'right',
    });
    const md = new MobileDetect(navigator.userAgent);

    return (
        <Fragment>
            <div key={title} className={featureClassName}>
                <div className={'tc-accordion-feature-container'}>
                    {md.phone() && builtImg}
                    {!md.phone() && imgAlign === 'left' && builtImg}
                    <div className="tc-accordion-feature-text">
                        <div className={`tc-accordion-feature-text-title ${theme}`}>{title}</div>
                        <div className={`tc-accordion-feature-text-content ${theme}`}>{content}</div>
                    </div>
                    {!md.phone() && imgAlign === 'right' && builtImg}
                </div>
            </div>
        </Fragment>
    );
};

export default connect(state => ({
    partner: state.products.get('partner'),
}))(CreditCardFeature);
